import Vue from 'vue'
import Router from 'vue-router'

//获取原型对象上的push函数 解决重复点击路由报错（不设也没影响）
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

import Layout from "../views/layout/Layout";
import app from "@/App.vue";

export const constantRouterMap = [
  {
    path: '/404',
    component: () => import('../views/404/404')
  },
  // 登录
  {
    path: '/login',
    component: () => import('../views/login/Login')
  },
  // 首页
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: '_home',
    meta: {title: '控制台', icon: 'el-icon-s-platform'},
    isSidebar: true,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta: {title: '欢迎页', icon: 'el-icon-s-home'},
        component: () => import('../views/dashboard/Dashboard'),
      },
    ]
  }
]

const asyncRoutes = [
  {
    path: '/stat',
    component: Layout,
    redirect: '/stat/adminStat',
    name: 'adminStat',
    meta: {title: '数据中心', icon: 'el-icon-s-data', roles: ['admin']},
    isSidebar: true,
    children: [
      {
        path: '/stat/dailyDashboard',
        name: 'AdminStatDailyDashboard',
        component: () => import('/src/views/stat/dailyDashboard'),
        meta: {title: '日数据图表', icon: 'el-icon-data-analysis', roles: ['admin']}
      },
      {
        path: '/stat/dailyStatementList',
        name: 'AdminStatDailyStatementList',
        component: () => import('/src/views/stat/dailyStatementList'),
        meta: {title: '日数据统计', icon: 'el-icon-data-line', roles: ['admin']}
      },
      {
        path: '/stat/monthlyStatementList',
        name: 'AdminStatMonthlyStatementList',
        component: () => import('/src/views/stat/monthlyStatementList'),
        meta: {title: '月数据统计', icon: 'el-icon-data-line', roles: ['admin']}
      }
    ]
  },
  // 管理员管理
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/adminUser',
    name: 'adminUser',
    meta: {title: '管理员管理', icon: 'el-icon-s-custom', roles: ['admin']}, // 管理员使用自定义用户图标
    isSidebar: true,
    children: [
      {
        path: '/admin/adminUser',
        name: 'AdminUser',
        component: () => import('/src/views/admin/adminUser/AdminUser'),
        meta: {title: '管理员管理', icon: 'el-icon-user', roles: ['admin']} // 用户图标
      },
      {
        path: '/admin/adminRole',
        name: 'AdminRole',
        component: () => import('/src/views/admin/adminRole/AdminRole'),
        meta: {title: '角色管理', icon: 'el-icon-s-check', roles: ['admin']} // 角色使用 check 图标
      }
    ]
  },
  // 用户管理
  {
    path: '/users',
    component: Layout,
    redirect: '/users/list',
    name: '_admin',
    meta: {title: '用户管理', icon: 'el-icon-user', roles: ['admin']}, // 用户使用 user 图标
    isSidebar: true,
    children: [
      {
        path: '/users/list',
        name: 'UsersList',
        component: () => import('/src/views/users/list'),
        meta: {title: '用户列表', icon: 'el-icon-s-custom', roles: ['admin']} // 用户列表自定义图标
      },
      {
        path: '/users/avatarAudit',
        name: 'avatarAuditList',
        component: () => import('/src/views/users/avatarAuditList'),
        meta: {title: '头像审核', icon: 'el-icon-picture-outline', roles: ['admin', 'auditor']}
      },
      {
        path: '/users/IMList',
        name: 'IMList',
        component: () => import('/src/views/users/IMList.vue'),
        meta: {title: '会话消息', icon: 'el-icon-chat-line-round', roles: ['admin']} // 用户列表自定义图标
      },
      {
        path: '/users/IMblack',
        name: 'IMblack',
        component: () => import('/src/views/users/IMblack.vue'),
        meta: {title: '会话黑名单', icon: 'el-icon-warning-outline', roles: ['admin']} // 用户列表自定义图标
      },
      {
        path: '/users/noticeList',
        name: 'NoticeList',
        component: () => import('/src/views/users/noticeList'),
        meta: {title: '消息列表', icon: 'el-icon-bell', roles: ['admin']} // 消息使用 bell 图标
      },
      {
        path: '/users/nurseMap',
        name: 'NurseMap',
        meta: {title: '护士地图', icon: 'el-icon-map-location', roles: ['admin']}, // 使用地图图标
        beforeEnter() {
          window.open('/nurseMap/nurseMap.html', '_blank'); // 在新标签页打开 nurseMap.html
        }
      },
      {
        path: '/users/cityQrCodeList',
        name: 'cityQrCodeList',
        component: () => import('/src/views/users/cityQrCodeList'),
        meta: {title: '城市群二维码', icon: 'el-icon-connection', roles: ['admin']}
      },
      {
        path: '/users/complaintSuggestionList',
        name: 'complaintSuggestionList',
        component: () => import('/src/views/users/complaintSuggestionList'),
        meta: {title: '投诉建议', icon: 'el-icon-bell', roles: ['admin']} // 消息使用 bell 图标
      },
      {
        path: '/users/deposit',
        name: 'deposit',
        component: () => import('/src/views/users/deposit'),
        meta: {title: '保证金', icon: 'el-icon-bell', roles: ['admin']} // 消息使用 bell 图标
      },
      {
        path: '/users/wallet',
        name: 'wallet',
        component: () => import('/src/views/users/wallet'),
        meta: {title: '钱包', icon: 'el-icon-s-order', roles: ['admin']} // 消息使用 bell 图标
      },
      {
        path: '/users/blackListPair',
        name: 'blackListPair',
        component: () => import('/src/views/users/blackListPair'),
        meta: {title: '用户黑名单', icon: 'el-icon-s-custom', roles: ['admin']} // 消息使用 bell 图标
      },
      {
        path: '/users/screenshotRecord',
        name: 'screenshotRecord',
        component: () => import('/src/views/users/screenshotRecord'),
        meta: {title: '用户截屏记录', icon: 'el-icon-s-custom', roles: ['admin']} // 消息使用 bell 图标
      },
    ]
  },
  // 订单管理
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    name: 'order',
    meta: {title: '订单管理', icon: 'el-icon-s-order', roles: ['admin']}, // 订单使用 order 图标
    isSidebar: true,
    children: [
      {
        path: '/order/list',
        name: 'OrderList',
        component: () => import('/src/views/order/list'),
        meta: {title: '订单列表', icon: 'el-icon-s-order', roles: ['admin']} // 订单列表也使用 order 图标
      },
      {
        path: '/order/notifyRecords',
        name: 'OrderNotifyRecords',
        component: () => import('/src/views/order/notifyRecords'),
        meta: {title: '回调记录', icon: 'el-icon-s-data', roles: ['admin']} // 数据图标
      },
      {
        path: '/order/redPacketList',
        name: 'redPacketList',
        component: () => import('/src/views/order/redPacketList'),
        meta: {title: '红包', icon: 'el-icon-s-order', roles: ['admin']} // 红包图标
      }
    ]
  },
  // 产品管理
  {
    path: '/product',
    component: Layout,
    redirect: '/product/list',
    name: '_productList',
    meta: {title: '产品管理', icon: 'el-icon-box', roles: ['admin']}, // 产品使用 box 图标
    isSidebar: true,
    children: [
      {
        path: '/product/list',
        name: 'productList',
        component: () => import('/src/views/product/list'),
        meta: {title: '产品列表', icon: 'el-icon-box', roles: ['admin']} // 同样使用 box 图标
      }
    ]
  },
  // 系统管理
  {
    path: '/manage',
    component: Layout,
    redirect: '',
    name: '_manageList',
    meta: {title: '系统管理', icon: 'el-icon-setting', roles: ['admin']}, // 系统使用 setting 图标
    isSidebar: true,
    children: [
      {
        path: '/manage/exportAllData',
        name: 'exportAllData',
        component: () => import('/src/views/manage/exportAllData.vue'),
        meta: {title: '导出所有数据', icon: 'el-icon-download', roles: ['admin']} // 下载图标
      },
      {
        path: '/orderLabel/list',
        name: 'orderLabelList',
        component: () => import('/src/views/orderLabel/list'),
        meta: {title: '订单标签列表', icon: 'el-icon-document-checked', roles: ['admin']} // 标签图标
      },
      {
        path: '/manage/PopupAds/index',
        name: 'PopupAds',
        component: () => import('/src/views/manage/PopupAds/index.vue'),
        meta: {title: '弹窗广告', icon: 'el-icon-copy-document', roles: ['admin']}
      },
      {
        path: '/manage/baseAnnouncement/index',
        name: 'baseAnnouncement',
        component: () => import('/src/views/manage/baseAnnouncement/index.vue'),
        meta: {title: '内容区', icon: 'el-icon-copy-document', roles: ['admin']}
      }
    ]
  },
  // 值集管理
  {
    path: '/valueSet',
    component: Layout,
    redirect: '/valueSet/list',
    name: '_valueSetList',
    meta: {title: '值集管理', icon: 'el-icon-folder', roles: ['admin']}, // 文件夹图标
    isSidebar: true,
    children: [
      {
        path: '/valueSet/valueSetOneLevelList',
        name: 'valueSetOneLevelList',
        component: () => import('/src/views/valueSet/valueSetOneLevelList'),
        meta: {title: '值集一级列表', icon: 'el-icon-folder', roles: ['admin']} // 文件夹图标
      },
      {
        path: '/valueSet/list',
        name: 'valueSetList',
        component: () => import('/src/views/valueSet/list'),
        meta: {title: '值集列表', icon: 'el-icon-folder', roles: ['admin']} // 文件夹图标
      },
    ]
  },
  // 审核管理
  {
    path: '/examine',
    component: Layout,
    redirect: '/examine/professionApply',
    name: '_examineNurseApply',
    meta: {title: '审核中心', icon: 'el-icon-s-check', roles: ['admin', 'auditor']}, // 审核中心使用 check 图标
    isSidebar: true,
    children: [
      {
        path: '/examine/professionApply',
        name: 'professionApply',
        component: () => import('/src/views/examine/professionApply'),
        meta: {title: '职业审核', icon: 'el-icon-s-check', roles: ['admin', 'auditor']} // 使用相同图标
      },
      {
        path: '/examine/orgApply',
        name: 'examineOrgApply',
        component: () => import('/src/views/examine/orgApply'),
        meta: {title: '机构入驻审核', icon: 'el-icon-office-building', roles: ['admin']} // 使用建筑物图标
      },
      {
        path: '/examine/realName',
        name: 'realName',
        component: () => import('/src/views/examine/realName'),
        meta: {title: '实名认证审核', icon: 'el-icon-s-check', roles: ['admin', 'auditor']} // 身份证图标
      },
      {
        path: '/examine/healthCertificate',
        name: 'healthCertificate',
        component: () => import('/src/views/examine/healthCertificate'),
        meta: {title: '健康证审核', icon: 'el-icon-s-check', roles: ['admin', 'auditor']} // 身份证图标
      },
      {
        path: '/examine/cashout',
        name: 'examineCashout',
        component: () => import('/src/views/examine/cashOut'),
        meta: {title: '提现审核', icon: 'el-icon-money', roles: ['admin']} // 钱袋图标
      },
      {
        path: '/examine/promotionCashOut',
        name: 'promotionCashOut',
        component: () => import('/src/views/examine/promotionCashOut'),
        meta: {title: '推广提现审核', icon: 'el-icon-s-check', roles: ['admin']} // 推广图标
      }
    ]
  },
  // 文章管理
  {
    path: '/article',
    component: Layout,
    redirect: '/article/list',
    name: '_articleList',
    meta: {title: '文章管理', icon: 'el-icon-document', roles: ['admin']}, // 文章使用 document 图标
    isSidebar: true,
    children: [
      {
        path: '/article/category',
        name: 'articleCategory',
        component: () => import('/src/views/article/category'),
        meta: {title: '文章分类管理', icon: 'el-icon-folder', roles: ['admin']} // 分类使用文件夹图标
      },
      {
        path: '/article/list',
        name: 'articleList',
        component: () => import('/src/views/article/list'),
        meta: {title: '文章列表', icon: 'el-icon-document', roles: ['admin']} // 文档图标
      },
      {
        path: '/article/edit',
        name: 'articleEdit',
        component: () => import('/src/views/article/edit'),
        meta: {title: '编辑文章', icon: 'el-icon-edit', hidden: true, roles: ['admin']} // 编辑图标
      }
    ]
  },
  // 兔币商城管理
  {
    path: '/rewardStore',
    component: Layout,
    redirect: '/rewardStore/orderList',
    name: 'rewardStore',
    meta: {title: '兔币商城', icon: 'el-icon-shopping-cart-full', roles: ['admin']}, // 商城使用购物车图标
    isSidebar: true,
    children: [
      {
        path: '/rewardStore/orderList',
        name: 'orderList',
        component: () => import('/src/views/rewardStore/orderList.vue'),
        meta: {title: '订单列表', icon: 'el-icon-tickets', roles: ['admin']} // 使用票图标
      }
    ]
  },
  {
    path: '/exam',
    component: Layout,
    redirect: '/exam/adminExam',
    name: 'exam',
    meta: {title: '考试管理', icon: 'el-icon-document-checked', roles: ['admin']}, // 顶级路由使用文档图标
    isSidebar: true,
    children: [
      {
        path: '/exam/adminExam',
        name: 'adminExam',
        component: () => import('/src/views/exam/adminExam.vue'),
        meta: {title: '考试管理', icon: 'el-icon-tickets', roles: ['admin']} // 使用票图标
      },
      {
        path: '/exam/adminExamRule',
        name: 'adminExamRule',
        component: () => import('/src/views/exam/adminExamRule.vue'),
        meta: {title: '规则管理', icon: 'el-icon-setting', roles: ['admin']} // 使用设置图标
      },
      {
        path: '/exam/adminExamWarehouse',
        name: 'adminExamWarehouse',
        component: () => import('/src/views/exam/adminExamWarehouse.vue'),
        meta: {title: '题库管理', icon: 'el-icon-s-management', roles: ['admin']} // 使用管理图标
      }
    ]
  }
]

// 工具函数：过滤路由权限
const filterRoutes = (routes, role) => {
  return routes.filter(route => {
    // 过滤子路由
    if (route.children) {
      route.children = filterRoutes(route.children, role)
      // 如果子路由为空则移除父路由
      if (route.children.length === 0) {
        return false
      }
    }

    // 修复可选链问题：兼容旧环境
    const meta = route.meta || {}
    const roles = meta.roles || []

    // 检查路由权限
    const hasPermission = roles.length === 0 || roles.includes(role)

    return hasPermission
  })
}

// 权限检查函数
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true // 没有设置权限的路由默认允许访问
  }
}

// 过滤动态路由
export function filterAsyncRoutes(routes,roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

// 动态添加路由
export function addRoleRoutes(role) {
  resetRouter()
  let accessedRoutes = filterAsyncRoutes(asyncRoutes,[role])
  accessedRoutes.forEach(route => {
    router.addRoute(route)
    router.options.routes.push(route)
  })
  localStorage.setItem('userRole', role)
}

// Vue2兼容的路由重置方法
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
  router.options.routes = [...newRouter.options.routes];
}

// 创建路由实例的工厂函数
const createRouter = () => new Router({
  routes: constantRouterMap
})

const router = createRouter()

export default router
